<!-- 工程EQ处理方式 -->
<template>
  <BaseFormItem
    isShowRequiredIcon
    class="smt-eq-notice"
    :label="label"
    labelTitle="PCB文件、SMT文件、SMT生产中存在EQ的确认方式通知："
    :labelTips="fields.labelTips"
    :fillTips="fillTips"
    :isError="isError"
    :isErrorBlink="isErrorBlink"
  >
    <template slot="labelTipsContent">
      <div class="smt-eq-notice__labelTips">
        ①平台推送（此方式便于EQ问题快速完结）：
        <ul style="list-style-type: disc;">
          <li>PCB：华秋将EQ（工程问题）推送到华秋电路官网、华秋公众号和DFM，贵司可进入华秋电路用户中心、华秋公众号和DFM查看及回复EQ</li>
          <li>SMT: 华秋将EQ（工程问题&生产问题）推送到华秋SMT官网，贵司可进入用户中心--PCBA订单列表页查看及回复EQ</li>
        </ul>
        ②、发送邮件
        <ul>
          <li>华秋将EQ以邮件形式发送到贵司工程师邮箱，贵司工程师通过邮件查看与回复EQ。（此方式为人工处理，如遇节假日或者非工作时间，可能不能及时确认，订单交期会受影响）</li>
        </ul>
      </div>
    </template>
    <BaseRadioGroup v-model="val" @change="handleEmit">
      <el-radio-button
        v-for="item in fields.options"
        :key="item.value"
        :label="item.value"
      >{{ item.label }}</el-radio-button>
    </BaseRadioGroup>
  </BaseFormItem>
</template>

<script>
import { getSMTFields, labelWarp } from '@@/utils/getFields'

export default {
  props: {
    value: {
      type: [Number, String],
      default: ''
    }
  },
  data() {
    return {
      val: this.value,
      isError: false, // 是否显示错误提示样式
      isErrorBlink: false, // 是否显示错误提示样式且闪两下
    }
  },
  computed: {
    fields() {
      return getSMTFields('eq_notice')
    },
    label() {
      // 换行展示label
      return labelWarp(this.fields.label, 4)
    },
    // 是否显示未填写样式
    fillTips() {
      const val = this.val
      return !val ? '请选择' : ''
    }
  },
  watch: {
    value(newVal) {
      this.val = +newVal
    }
  },
  methods: {
    handleEmit() {
      const val = this.val
      this.$emit('input', val)
      this.$emit('change', val)
      this.isShowError(false)
    },
    // 是否显示错误提示样式
    isShowError(isShow, isBlink = false) {
      this.isError = isShow
      this.isErrorBlink = isBlink
    }
  }
}
</script>

<style lang="scss" scoped>
.smt-eq-notice__labelTips {
  li {
    list-style: disc;
    margin-left: 30px;
  }
}
</style>